import { createContext } from 'react'
import { SWIPEABLE_VIEW_INITIAL_VALUES } from './constants'

const SwipeableViewContext = createContext(SWIPEABLE_VIEW_INITIAL_VALUES)

export default SwipeableViewContext
